import { DEFAULT_CURRENCY } from "src/constants"

export const formatPrivateMoney = (valueInCents: number, currency = DEFAULT_CURRENCY) => {
	const value = Number(valueInCents || 0) / 100
	try {
		return new Intl.NumberFormat("en-US", {
			style: "currency",
			currency,
			currencyDisplay: "narrowSymbol",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}).format(value)
	} catch {
		return `${currency} ${value.toFixed(2)}`
	}
}
